import { Interval } from "@contentchef/contentchef-types";
import { PaymentFlow } from "./PaymentFlow";

export class DefaultPaymentFlow extends PaymentFlow {
  async pay(subscriptionId: string, planId: string, interval: Interval, token?: stripe.Token) {
    const tokenToUse = token ? token.id : this.token!.id;
    try {
      return await this.paymentStore.changePlan(subscriptionId, parseInt(planId, 10), tokenToUse, interval);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
